import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { hasConsented, acceptAllCookies, rejectAllCookies } from '../utils/cookieUtils';
import CookieManager from './CookieManager';
import './CookieBanner.css';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showManager, setShowManager] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    if (!hasConsented()) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    acceptAllCookies();
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    rejectAllCookies();
    setShowBanner(false);
  };

  const handleCustomize = () => {
    setShowManager(true);
  };

  const handleManagerClose = () => {
    setShowManager(false);
    // Check if consent was given in the manager
    if (hasConsented()) {
      setShowBanner(false);
    }
  };

  if (!showBanner) {
    return null;
  }

  return (
    <>
      <div className="cookie-banner-overlay" onClick={handleRejectAll}></div>
      <div className="cookie-banner">
        <div className="cookie-banner-content">
          <div className="cookie-banner-text">
            <h3 className="cookie-banner-title">We Value Your Privacy</h3>
            <p className="cookie-banner-description">
              We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept All", you consent to our use of cookies. You can also choose to customize your preferences or reject non-essential cookies.
            </p>
          </div>
          <div className="cookie-banner-actions">
            <button 
              className="cookie-btn cookie-btn-reject" 
              onClick={handleRejectAll}
            >
              Reject All
            </button>
            <button 
              className="cookie-btn cookie-btn-customize" 
              onClick={handleCustomize}
            >
              Customize
            </button>
            <button 
              className="cookie-btn cookie-btn-accept" 
              onClick={handleAcceptAll}
            >
              Accept All
            </button>
          </div>
          <div className="cookie-banner-links">
            <Link to="/cookie-policy" className="cookie-banner-link">
              Learn more about our Cookie Policy
            </Link>
          </div>
        </div>
      </div>
      {showManager && (
        <CookieManager onClose={handleManagerClose} />
      )}
    </>
  );
};

export default CookieBanner;

